/* ═══════════════════════════════════════════════
   DEATH BY CROSS — SHOPIFY THEME JS
   theme.js
═══════════════════════════════════════════════ */

'use strict';

/* ─── INIT ─── */
document.addEventListener('DOMContentLoaded', function () {
  initPreloader();
  initAntiDemon();
  initCartAjax();
  initActiveNav();
});

/* ═══════════════════════════════════════════════
   PRE-LOADER
═══════════════════════════════════════════════ */
function initPreloader() {
  var pl  = document.getElementById('preloader');
  var vid = document.getElementById('pl-video');
  if (!pl) return;

  // Show preloader only on:
  // 1. First ever visit (no sessionStorage key)
  // 2. Hard reload / F5 (navigation type 1 = reload)
  var isReload = (
    performance.navigation && performance.navigation.type === 1
  ) || (
    performance.getEntriesByType &&
    performance.getEntriesByType('navigation')[0] &&
    performance.getEntriesByType('navigation')[0].type === 'reload'
  );

  var alreadySeen = sessionStorage.getItem('dbc_seen');

  if (alreadySeen && !isReload) {
    // Navigation between pages — skip preloader instantly
    if (pl.parentNode) pl.parentNode.removeChild(pl);
    return;
  }

  function dismiss() {
    sessionStorage.setItem('dbc_seen', '1');
    pl.classList.add('hide');
    setTimeout(function() { if (pl.parentNode) pl.parentNode.removeChild(pl); }, 1100);
  }

  if (vid) {
    vid.addEventListener('ended', function () { setTimeout(dismiss, 350); });
    vid.addEventListener('error',  function () { setTimeout(dismiss, 800); });
    setTimeout(function () {
      if (!pl.classList.contains('hide')) dismiss();
    }, 6000);
  } else {
    setTimeout(dismiss, 3000);
  }
}

function skipPreloader() {
  var pl = document.getElementById('preloader');
  if (!pl || pl.classList.contains('hide')) return;
  sessionStorage.setItem('dbc_seen', '1');
  pl.classList.add('hide');
  setTimeout(function() { if (pl.parentNode) pl.parentNode.removeChild(pl); }, 1100);
}

/* ═══════════════════════════════════════════════
   ANTI-DEMON
═══════════════════════════════════════════════ */
var isLoggedIn = false;

function initAntiDemon() {
  initStaticCanvas();
}

function triggerAntiDemon() {
  if (isLoggedIn) { showToast('ACCESS GRANTED — WELCOME, SOLDIER'); return; }
  var el = document.getElementById('antidemon-screen');
  if (el) { el.classList.add('open'); document.body.style.overflow = 'hidden'; }
}

function closeAntiDemon() {
  var el = document.getElementById('antidemon-screen');
  if (el) { el.classList.remove('open'); document.body.style.overflow = ''; }
}

function initStaticCanvas() {
  var canvas = document.getElementById('static-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');

  function resize() {
    canvas.width  = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  resize();
  window.addEventListener('resize', resize);

  function drawStatic() {
    var ad = document.getElementById('antidemon-screen');
    if (!ad || !ad.classList.contains('open')) {
      requestAnimationFrame(drawStatic); return;
    }
    var id = ctx.createImageData(canvas.width, canvas.height);
    for (var i = 0; i < id.data.length; i += 4) {
      var v = Math.random() > 0.5 ? 255 : 0;
      id.data[i] = v; id.data[i+1] = v; id.data[i+2] = v;
      id.data[i+3] = Math.random() * 180 + 40;
    }
    ctx.putImageData(id, 0, 0);
    if (Math.random() > 0.7) {
      ctx.fillStyle = 'rgba(139,0,0,' + (Math.random() * 0.8) + ')';
      ctx.fillRect(0, Math.random() * canvas.height, canvas.width, Math.random() * 4 + 1);
    }
    requestAnimationFrame(drawStatic);
  }
  drawStatic();
}

/* ═══════════════════════════════════════════════
   CART DRAWER  — FALLING LOGOS CANVAS
═══════════════════════════════════════════════ */
var cartOpen = false;
var logosAnimFrame = null;
var logoParticles   = [];
var logoImage       = null;

function openCart() {
  var overlay = document.getElementById('cart-overlay');
  var sidebar = document.getElementById('cart-sidebar');
  if (!overlay || !sidebar) return;
  if (cartOpen) return; /* já aberto */
  cartOpen = true;
  overlay.classList.add('open');
  sidebar.classList.add('open');
  document.body.style.overflow = 'hidden';
  startFallingLogos();
}

function closeCart() {
  var overlay = document.getElementById('cart-overlay');
  var sidebar = document.getElementById('cart-sidebar');
  if (!overlay || !sidebar) return;
  cartOpen = false;
  overlay.classList.remove('open');
  sidebar.classList.remove('open');
  document.body.style.overflow = '';
  stopFallingLogos();
}

function toggleCart() {
  if (cartOpen) { closeCart(); } else { openCart(); }
}

/* ── Falling logos canvas ── */
function startFallingLogos() {
  var canvas = document.getElementById('logos-canvas');
  if (!canvas) return;

  var ctx = canvas.getContext('2d');
  var W = canvas.offsetWidth || 460;
  var H = canvas.offsetHeight || window.innerHeight;
  canvas.width  = W;
  canvas.height = H;

  /* load the logo image once */
  if (!logoImage) {
    logoImage = new Image();
    /* get the src from the header logo which is already loaded */
    var hdrLogo = document.querySelector('.header-logo-img');
    if (hdrLogo) logoImage.src = hdrLogo.src;
  }

  /* spawn particles */
  logoParticles = [];
  var count = 18;
  for (var i = 0; i < count; i++) {
    logoParticles.push(spawnLogoParticle(W, H, true));
  }

  function loop() {
    ctx.clearRect(0, 0, W, H);

    logoParticles.forEach(function (p, idx) {
      p.y     += p.vy;
      p.x     += p.vx;
      p.angle += p.spin;

      /* reset when off screen */
      if (p.y > H + p.size) {
        logoParticles[idx] = spawnLogoParticle(W, H, false);
        return;
      }

      ctx.save();
      ctx.globalAlpha = p.alpha;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.angle);
      if (logoImage && logoImage.complete) {
        ctx.drawImage(logoImage, -p.size/2, -p.size/2, p.size, p.size);
      } else {
        /* fallback: draw a simple cross */
        ctx.strokeStyle = 'rgba(139,0,0,0.6)';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(0, -p.size/2); ctx.lineTo(0, p.size/2);
        ctx.moveTo(-p.size/3, -p.size/6); ctx.lineTo(p.size/3, -p.size/6);
        ctx.stroke();
      }
      ctx.restore();
    });

    logosAnimFrame = requestAnimationFrame(loop);
  }

  logosAnimFrame = requestAnimationFrame(loop);
}

function spawnLogoParticle(W, H, randomY) {
  return {
    x:     Math.random() * W,
    y:     randomY ? Math.random() * H * -1 : -60,
    vy:    0.4 + Math.random() * 1.2,
    vx:    (Math.random() - 0.5) * 0.4,
    size:  28 + Math.random() * 42,
    angle: Math.random() * Math.PI * 2,
    spin:  (Math.random() - 0.5) * 0.015,
    alpha: 0.06 + Math.random() * 0.12
  };
}

function stopFallingLogos() {
  if (logosAnimFrame) {
    cancelAnimationFrame(logosAnimFrame);
    logosAnimFrame = null;
  }
  logoParticles = [];
  var canvas = document.getElementById('logos-canvas');
  if (canvas) {
    var ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);
  }
}

/* ═══════════════════════════════════════════════
   CART AJAX  (Shopify Cart API)
═══════════════════════════════════════════════ */
function initCartAjax() {
  refreshCartCount();
}

function addToCartShopify(variantId, event, qty) {
  if (event) event.preventDefault();
  var quantity = qty || 1;

  fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body:    JSON.stringify({ id: variantId, quantity: quantity })
  })
  .then(function(r){ return r.json(); })
  .then(function(data) {
    if (data.status === 422) {
      var unavailMsg = (typeof localStorage !== 'undefined' && localStorage.getItem('dbc-lang') === 'en') ? 'Item unavailable' : 'Item indisponível';
      showToast(unavailMsg); return;
    }
    var isEn = (typeof localStorage !== 'undefined' && localStorage.getItem('dbc-lang') === 'en');
    var addedMsg = isEn ? (( data.title || 'Item') + ' — Added to Arsenal') : ((data.title || 'Item') + ' — Adicionado ao Arsenal');
    showToast(addedMsg);
    refreshCartDrawer();
    /* abrir carrinho automaticamente */
    setTimeout(function(){ openCart(); }, 300);
    /* feedback no botão da página de produto */
    var btn = document.getElementById('product-atc-btn');
    if (btn) {
      var orig = btn.textContent;
      btn.textContent = isEn ? '✓ Added' : '✓ Adicionado';
      setTimeout(function(){ btn.textContent = orig; }, 1800);
    }
  })
  .catch(function(){
    var isEn2 = (typeof localStorage !== 'undefined' && localStorage.getItem('dbc-lang') === 'en');
    showToast(isEn2 ? 'Error adding to cart' : 'Erro ao adicionar ao carrinho');
  });
}

function cartUpdateQty(key, qty, maxQty) {
  // Bloquear acima do estoque disponível
  if (maxQty !== undefined && maxQty !== null && qty > maxQty) {
    showToast('Só temos ' + maxQty + ' unidade(s) disponível(is)');
    return;
  }
  if (qty < 0) qty = 0;
  var updates = {};
  updates[key] = qty;
  fetch('/cart/update.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ updates: updates })
  })
  .then(function(r){ return r.json(); })
  .then(function(){ refreshCartDrawer(); })
  .catch(function(){ showToast('Erro ao atualizar carrinho'); });
}

function refreshCartDrawer() {
  fetch('/cart.js')
  .then(function(r){ return r.json(); })
  .then(function(cart) {
    updateCartBadge(cart.item_count);
    renderCartDrawerItems(cart);
  });
}

function refreshCartCount() {
  fetch('/cart.js')
  .then(function(r){ return r.json(); })
  .then(function(cart){ updateCartBadge(cart.item_count); });
}

function updateCartBadge(count) {
  var badge = document.getElementById('cart-badge');
  if (!badge) return;
  badge.textContent = count;
  badge.classList.remove('bump');
  void badge.offsetWidth;
  badge.classList.add('bump');
}

function renderCartDrawerItems(cart) {
  var wrap   = document.getElementById('cart-items-wrap');
  var total  = document.getElementById('cart-total-amount');
  if (!wrap) return;

  if (total) total.textContent = formatMoney(cart.total_price);

  /* atualizar contador no header do cart */
  var headCount = document.getElementById('cart-head-count-num');
  if (headCount) headCount.textContent = cart.item_count;
  var headCountWrap = headCount && headCount.parentElement;
  if (headCountWrap) {
    var isEn = (localStorage.getItem('dbc-lang') === 'en');
    var piecesSpan = headCountWrap.querySelectorAll('span')[1];
    if (piecesSpan) piecesSpan.textContent = isEn ? (cart.item_count === 1 ? 'piece' : 'pieces') : (cart.item_count === 1 ? 'peça' : 'peças');
  }

  if (cart.item_count === 0) {
    closeCart();
    return;
  }

  var lang = localStorage.getItem('dbc-lang') || 'pt';
  var removeLabel = lang === 'en' ? 'Remove' : 'Remover';

  var sidebar = document.getElementById('cart-sidebar');
  var frameUrl = sidebar ? (sidebar.getAttribute('data-frame-url') || '') : '';

  wrap.innerHTML = cart.items.map(function(item) {
    var imgSrc = item.image
      ? item.image.replace('http:', 'https:')
      : getLogoUrl();
    var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="cart-item-variant">' + item.variant_title + '</div>'
      : '';
    var maxQty = (item.inventory_management && item.inventory_policy !== 'continue')
      ? item.inventory_quantity
      : 999;
    var atMax = (maxQty !== 999 && item.quantity >= maxQty);
    var plusDisabled = atMax ? ' disabled title="Limite de estoque"' : '';
    var stockWarn = atMax
      ? '<div class="cart-stock-warn">Máx: ' + maxQty + '</div>'
      : '';
    var frameHtml = frameUrl
      ? '<img src="' + frameUrl + '" alt="" class="cart-item-frame" aria-hidden="true">'
      : '';
    return (
      '<div class="cart-item">' +
        '<div class="cart-item-thumb">' +
          '<img src="' + imgSrc + '" alt="' + escHtml(item.product_title) + '" class="cart-item-photo">' +
          frameHtml +
        '</div>' +
        '<div class="cart-item-right">' +
          '<div class="cart-item-name">' + escHtml(item.product_title) + '</div>' +
          variantHtml +
          '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
          '<div class="cart-item-qty-row">' +
            '<button class="qty-btn" onclick="cartUpdateQty(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>' +
            '<span class="qty-num">' + item.quantity + '</span>' +
            '<button class="qty-btn"' + plusDisabled + ' onclick="cartUpdateQty(\'' + item.key + '\',' + (item.quantity + 1) + ',' + maxQty + ')">+</button>' +
          '</div>' +
          stockWarn +
          '<button class="cart-item-remove" onclick="cartUpdateQty(\'' + item.key + '\',0)">' + removeLabel + '</button>' +
        '</div>' +
      '</div>'
    );
  }).join('');
}

/* ─── helpers ─── */
function getLogoUrl() {
  var img = document.querySelector('.header-logo-img');
  return img ? img.src : '';
}
function formatMoney(cents) {
  var value = (cents / 100).toFixed(2).replace('.', ',');
  return 'R$ ' + value;
}
function escHtml(str) {
  return String(str)
    .replace(/&/g,'&amp;').replace(/</g,'&lt;')
    .replace(/>/g,'&gt;').replace(/"/g,'&quot;');
}

/* ─── active nav ─── */
function initActiveNav() {
  var path = window.location.pathname;
  document.querySelectorAll('.nav-link[data-page]').forEach(function(a) {
    if (path === '/'                          && a.dataset.page === 'home')        a.classList.add('active');
    if (path === '/collections/men'           && a.dataset.page === 'men')         a.classList.add('active');
    if (path === '/collections/woman'         && a.dataset.page === 'woman')       a.classList.add('active');
    if (path === '/collections/all'           && a.dataset.page === 'all')         a.classList.add('active');
    if (path === '/pages/about-us'            && a.dataset.page === 'about')       a.classList.add('active');
    if (path === '/pages/anti-demon'          && a.dataset.page === 'anti-demon')  a.classList.add('active');
  });
}

/* ─── toast ─── */
function showToast(msg) {
  var t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(function(){ t.classList.remove('show'); }, 2600);
}

/* ═══ USER LOGIN / ANTI-DEMON GATE ═══ */
var DEMO_EMAIL = 'warrior@dbc.com';
var DEMO_PASS  = 'cross2025';

function toggleMobileMenu() {
  var btn     = document.getElementById('mobile-menu-btn');
  var drawer  = document.getElementById('mobile-menu-drawer');
  var overlay = document.getElementById('mobile-menu-overlay');
  var isOpen  = drawer.classList.contains('open');
  btn.classList.toggle('open', !isOpen);
  drawer.classList.toggle('open', !isOpen);
  overlay.classList.toggle('open', !isOpen);
  document.body.style.overflow = isOpen ? '' : 'hidden';
}

/* ══ MOBILE PRODUCT CAROUSEL ══ */
var carouselIndex = 0;

function carouselNext() {
  var track  = document.getElementById('mobile-carousel-track');
  if (!track) return;
  var slides = track.querySelectorAll('.carousel-slide');
  if (!slides.length) return;
  carouselIndex = (carouselIndex + 1) % slides.length;
  track.style.transform = 'translateX(-' + (carouselIndex * 100) + '%)';
}

function carouselPrev() {
  var track  = document.getElementById('mobile-carousel-track');
  if (!track) return;
  var slides = track.querySelectorAll('.carousel-slide');
  if (!slides.length) return;
  carouselIndex = (carouselIndex - 1 + slides.length) % slides.length;
  track.style.transform = 'translateX(-' + (carouselIndex * 100) + '%)';
}

/* Swipe support for carousel */
(function() {
  var startX = 0;
  document.addEventListener('touchstart', function(e) {
    var track = document.getElementById('mobile-carousel-track');
    if (track && track.contains(e.target)) startX = e.touches[0].clientX;
  }, {passive: true});
  document.addEventListener('touchend', function(e) {
    var track = document.getElementById('mobile-carousel-track');
    if (!track || !track.contains(e.target)) return;
    var diff = startX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) carouselNext(); else carouselPrev();
    }
  }, {passive: true});
})();

/* ══ PRODUCTS CAROUSEL (desktop + mobile) ══ */
var productsIdx = 0;

function getProductsPerView() {
  return window.innerWidth <= 768 ? 1 : 4;
}

function productsCarouselNext() {
  var track  = document.getElementById('products-carousel-track');
  if (!track) return;
  var slides = track.querySelectorAll('.products-carousel-slide');
  var perView = getProductsPerView();
  var maxIdx  = Math.ceil(slides.length / perView) - 1;
  productsIdx = productsIdx >= maxIdx ? 0 : productsIdx + 1;
  updateProductsCarousel();
}

function productsCarouselPrev() {
  var track  = document.getElementById('products-carousel-track');
  if (!track) return;
  var slides = track.querySelectorAll('.products-carousel-slide');
  var perView = getProductsPerView();
  var maxIdx  = Math.ceil(slides.length / perView) - 1;
  productsIdx = productsIdx <= 0 ? maxIdx : productsIdx - 1;
  updateProductsCarousel();
}

function updateProductsCarousel() {
  var track = document.getElementById('products-carousel-track');
  if (!track) return;
  var perView = getProductsPerView();
  var pct = (100 / perView) * productsIdx;
  track.style.transform = 'translateX(-' + pct + '%)';
}

/* Touch swipe on products carousel */
(function() {
  var sx = 0;
  document.addEventListener('touchstart', function(e) {
    var t = document.getElementById('products-carousel-track');
    if (t && t.contains(e.target)) sx = e.touches[0].clientX;
  }, {passive: true});
  document.addEventListener('touchend', function(e) {
    var t = document.getElementById('products-carousel-track');
    if (!t || !t.contains(e.target)) return;
    var diff = sx - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) productsCarouselNext(); else productsCarouselPrev();
    }
  }, {passive: true});
})();

window.addEventListener('resize', function() {
  productsIdx = 0;
  updateProductsCarousel();
});

/* ============================================================
   SFH — FEATURED PRODUCT HERO CAROUSEL
   Slide animation: o quadro inteiro desliza pra fora/dentro
============================================================ */
(function() {
  var slides  = [];
  var dots    = [];
  var cur     = 0;
  var busy    = false;
  var timer   = null;
  var DELAY   = 5500;
  var DUR     = 520; // duração da animação em ms

  function init() {
    slides = Array.from(document.querySelectorAll('.sfh-slide'));
    dots   = Array.from(document.querySelectorAll('.sfh-dot'));
    if (!slides.length) return;

    // Pré-carregar todas as imagens
    slides.forEach(function(slide) {
      slide.querySelectorAll('img').forEach(function(img) {
        img.loading = 'eager';
      });
    });

    // Posicionar slides: o ativo em 0, os outros fora à direita
    slides.forEach(function(s, i) {
      s.style.position  = 'absolute';
      s.style.top       = '0';
      s.style.left      = '0';
      s.style.width     = '100%';
      s.style.transform = i === 0 ? 'translateX(0)' : 'translateX(110%)';
      s.style.opacity   = i === 0 ? '1' : '0';
      s.style.display   = 'grid';
      s.style.transition = 'none';
    });

    // Primeiro slide fica como relative para dar altura ao sfh-outer
    slides[0].style.position = 'relative';

    cur = 0;
    updateDots(0);
    slides[0].classList.add('sfh-slide--active');
    startAuto();

    // Swipe
    var outer = document.getElementById('sfh-outer');
    if (outer) {
      var sx = 0;
      outer.addEventListener('touchstart', function(e) { sx = e.touches[0].clientX; }, {passive:true});
      outer.addEventListener('touchend', function(e) {
        var dx = sx - e.changedTouches[0].clientX;
        if (Math.abs(dx) > 40) { stopAuto(); dx > 0 ? next() : prev(); }
      }, {passive:true});
      outer.addEventListener('mouseenter', stopAuto);
      outer.addEventListener('mouseleave', startAuto);
    }
  }

  function goTo(idx, direction) {
    if (busy || idx === cur) return;
    busy = true;
    stopAuto();

    var dir    = (direction === 'prev') ? -1 : 1;
    var outEl  = slides[cur];
    var inEl   = slides[idx];

    // O elemento que entra começa fora da tela
    inEl.style.transition = 'none';
    inEl.style.transform  = 'translateX(' + (dir * 110) + '%)';
    inEl.style.opacity    = '1';
    inEl.style.position   = 'absolute';

    // Deixar o layout ativo (o que sai) como relative para manter altura
    outEl.style.position = 'relative';

    // Força reflow
    inEl.getBoundingClientRect();

    // Animar
    var easing = 'cubic-bezier(0.77, 0, 0.18, 1)';
    inEl.style.transition  = 'transform ' + DUR + 'ms ' + easing + ', opacity ' + DUR + 'ms ease';
    outEl.style.transition = 'transform ' + DUR + 'ms ' + easing + ', opacity ' + DUR + 'ms ease';

    inEl.style.transform  = 'translateX(0)';
    inEl.style.opacity    = '1';
    outEl.style.transform = 'translateX(' + (-dir * 110) + '%)';
    outEl.style.opacity   = '0.4';

    updateDots(idx);
    // Atualiza classe active para acessibilidade e CSS
    slides.forEach(function(s, i) { s.classList.toggle('sfh-slide--active', i === idx); });
    cur = idx;

    setTimeout(function() {
      outEl.style.transition = 'none';
      outEl.style.position   = 'absolute';
      outEl.style.opacity    = '0';
      inEl.style.position    = 'relative'; // agora inEl mantém a altura
      busy = false;
      startAuto();
    }, DUR + 20);
  }

  function updateDots(idx) {
    dots.forEach(function(d, i) {
      d.classList.toggle('sfh-dot--active', i === idx);
    });
  }

  function next() { goTo((cur + 1) % slides.length, 'next'); }
  function prev() { goTo((cur - 1 + slides.length) % slides.length, 'prev'); }

  function startAuto() {
    stopAuto();
    timer = setInterval(function() { next(); }, DELAY);
  }
  function stopAuto() {
    if (timer) { clearInterval(timer); timer = null; }
  }

  /* Globals */
  window.sfhNext  = function() { stopAuto(); next(); };
  window.sfhPrev  = function() { stopAuto(); prev(); };
  window.sfhGoTo  = function(i) { stopAuto(); goTo(i); };

  window.sfhSelectSize = function(btn) {
    var wrap = btn.closest('.sfh-sizes');
    if (!wrap) return;
    wrap.querySelectorAll('.sfh-size-btn').forEach(function(b) {
      b.classList.remove('sfh-size-btn--active');
    });
    btn.classList.add('sfh-size-btn--active');
  };

  window.sfhAddToCart = function(btn) {
    var slide = btn.closest('.sfh-slide');
    if (!slide) return;
    var activeSize = slide.querySelector('.sfh-size-btn--active');
    if (!activeSize) { return; }
    var variantId = activeSize.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    var span = btn.querySelector('[data-i18n]');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (span) span.textContent = '✓ Adicionado';
      var isEn = localStorage.getItem('dbc-lang') === 'en';
      var productName = (data && data.title) ? data.title : (slide.querySelector('.sfh-name') ? slide.querySelector('.sfh-name').textContent.trim() : '');
      var toastMsg = isEn ? (productName + ' — Added to Arsenal') : (productName + ' — Adicionado ao Arsenal');
      showToast(toastMsg);
      // Update badge
      return fetch('/cart.js');
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      updateCartBadge(cart.item_count);
      renderCartDrawerItems(cart);
      if (!cartOpen) openCart();
      setTimeout(function() {
        btn.disabled = false;
        if (span) {
          span.dataset.i18n = 'product.add_cart';
          span.textContent = 'Adicionar ao Carrinho';
        }
      }, 2000);
    })
    .catch(function() { btn.disabled = false; });
  };

  document.addEventListener('DOMContentLoaded', init);
})();

/* ============================================================
   LANGUAGE TOGGLE PILL  —  PT ↔ EN
   Cobre todas as strings visíveis do site
============================================================ */
(function() {

  /* ── Mapa completo de traduções ── */
  var T = {
    /* ── Nav ── */
    'nav.home':     { pt: 'Início',   en: 'Home' },
    'nav.men':      { pt: 'Men',      en: 'Men' },
    'nav.woman':    { pt: 'Woman',    en: 'Woman' },
    'nav.all':      { pt: 'All',      en: 'All' },
    'nav.shop':     { pt: 'Loja',     en: 'Shop All' },
    'nav.about':    { pt: 'Sobre',    en: 'About Us' },
    'nav.magazine': { pt: 'Revistas',  en: 'Magazine' },
    'nav.ranking':  { pt: 'Hall of War',  en: 'Hall of War' },
    'mag.index.title': { pt: 'Revistas', en: 'Magazine' },
    'mag.index.sub':   { pt: 'Death by Cross · Edições', en: 'Death by Cross · Issues' },
    'mag.vol':         { pt: 'Vol.', en: 'Vol.' },
    'mag.vol01':       { pt: 'Vol. 01', en: 'Vol. 01' },
    'mag.pantoja':     { pt: 'Alexandre Pantoja', en: 'Alexandre Pantoja' },
    'rank.title':   { pt: 'Top Compradores', en: 'Top Buyers' },
    'rank.since':   { pt: 'Desde o Início',  en: 'Since the Beginning' },
    'rank.tag':     { pt: 'Divisão Anti-Demônio • Hall of War', en: 'Anti-Demon Division • Hall of War' },
    'rank.empty':   { pt: '— Vaga disponível —', en: '— Slot Available —' },
    'rank.orders0': { pt: '0 Pedidos', en: '0 Orders' },
    'rank.footer':  { pt: 'Não Ouça o Diabo · Lute ou Morra', en: "Don't Listen to the Devil · Fight or Die" },

    /* ── Announcement bar ── */
    'ann.text': {
      pt: 'DROP DISPONÍVEL AGORA • ESTOQUE EXTREMAMENTE LIMITADO • WEAR THE WAR • FIGHT EQUIPPED • DIE WORTHY • NÃO OUÇA O DIABO •',
      en: 'DROP AVAILABLE NOW • EXTREMELY LIMITED STOCK • WEAR THE WAR • FIGHT EQUIPPED • DIE WORTHY • DON\'T LISTEN TO THE DEVIL •'
    },

    /* ── Hero ── */
    'hero.scroll': { pt: 'Rolar para baixo', en: 'Go Down' },

    /* ── Hero produto seção ── */
    'home.arsenal':  { pt: 'Arsenal',      en: 'Arsenal' },
    'home.wear_war': { pt: 'Wear the War', en: 'Wear the War' },
    'home.view_all': { pt: 'Ver Tudo →',   en: 'View All →' },

    /* ── Produto ── */
    'product.size':      { pt: 'Tamanho',              en: 'Size' },
    'product.one_size':  { pt: 'Tamanho Único',         en: 'One Size' },
    'product.add_cart':  { pt: 'Adicionar ao Carrinho', en: 'Add to Cart' },
    'product.sold_out':  { pt: 'Esgotado',              en: 'Sold Out' },
    'product.added':     { pt: '✓ Adicionado',          en: '✓ Added' },
    'product.view_details': { pt: 'Ver detalhes →',     en: 'View details →' },
    'product.see_desc':  { pt: 'Ver descrição completa', en: 'View full description' },
    'product.subtitle':  { pt: 'Parte do Arsenal. Usada por quem escolheu um lado.', en: 'Part of the Arsenal. Worn by those who chose a side.' },
    'product.brand_headline': { pt: 'Você não chegou até aqui por acaso.<br>Isso não é só uma peça. É parte do seu arsenal.', en: 'You didn\'t end up here by accident.<br>This is not just a piece. It\'s part of your arsenal.' },
    'product.brand_body1': { pt: 'Em um mundo que pertence ao maligno, ir contra é a escolha mais difícil.<br>Cada detalhe desta obra carrega um posicionamento.', en: 'In a world that belongs to the evil one, going against it is the hardest choice.<br>Every detail of this piece carries a statement.' },
    'product.brand_body2': { pt: 'Aqui não existem espectadores. Apenas soldados que decidiram ir para a guerra.', en: 'There are no spectators here. Only soldiers who decided to go to war.' },
    'product.brand_body3': { pt: 'Quando o maligno te lembrar do seu passado, lembre ele do futuro dele.', en: 'When the evil one reminds you of your past, remind him of his future.' },
    'product.brand_body4': { pt: 'Estilo é consequência daquilo que você decide representar.', en: 'Style is the consequence of what you decide to represent.' },

    /* ── Seção borboleta ── */
    'butterfly.eyebrow': { pt: 'Morte & Ressurreição', en: 'Death & Resurrection' },
    'butterfly.title':   { pt: 'Morrer é Renascer',    en: 'To Die is to Be Reborn' },
    'butterfly.body': {
      pt: 'A carne precisa morrer para o espírito se elevar.<br>Pecado enterrado. Propósito ressuscitado.<br><em>Esse é o caminho da cruz.</em>',
      en: 'The flesh must die so the spirit can rise.<br>Sin buried. Purpose resurrected.<br><em>This is the way of the cross.</em>'
    },
    'butterfly.cta': { pt: 'Entrar na Luta', en: 'Join the War' },

    /* ── CTA final ── */
    'cta.title': { pt: 'Don\'t Listen to the Devil.', en: 'Don\'t Listen to the Devil.' },
    'cta.sub':   { pt: 'Death By Cross — A Luta Continua',       en: 'Death By Cross — The Fight Continues' },
    'cta.btn':   { pt: 'Entrar na Guerra',                       en: 'Join the War' },

    /* ── Cart drawer ── */
    'cart.title':         { pt: 'Seu Arsenal',                   en: 'Your Arsenal' },
    'cart.eyebrow':       { pt: 'Arsenal',                       en: 'Arsenal' },
    'cart.pieces':        { pt: 'peças',                         en: 'pieces' },
    'cart.empty_title':   { pt: 'Arsenal Vazio',                 en: 'Empty Arsenal' },
    'cart.empty_sub':     { pt: 'Sem peças ainda. Equipe-se.',   en: 'No pieces yet. Gear up.' },
    'cart.checkout':      { pt: 'Finalizar Compra',              en: 'Checkout' },
    'cart.remove':        { pt: 'Remover',                       en: 'Remove' },
    'cart.subtotal':      { pt: 'Subtotal',                      en: 'Subtotal' },
    'cart.shipping_note': { pt: 'Frete calculado no checkout',   en: 'Shipping calculated at checkout' },
    'cart.keep_shopping': { pt: 'Continuar Comprando',           en: 'Continue Shopping' },

    /* ── Lookbook ── */
    'lookbook.hero_label':  { pt: 'A Campanha',         en: 'The Campaign' },
    'lookbook.hero_title':  { pt: 'Wear the War',       en: 'Wear the War' },
    'lookbook.cta':         { pt: 'Ver o Arsenal →',    en: 'View Arsenal →' },
    'lookbook.cta2':        { pt: 'Garantir a Minha →', en: 'Get Mine →' },
    'lookbook.exclusive1':  { pt: 'Nem todo mundo vai ter acesso. Você ainda pode.', en: 'Not everyone will have access. You still can.' },
    'lookbook.exclusive2':  { pt: 'ESTOQUE LIMITADO.',  en: 'LIMITED STOCK.' },

    /* ── About ── */
    'about.back':  { pt: '← Voltar',  en: '← Back' },

    /* ── Footer ── */
    'footer.shop':     { pt: 'Loja',          en: 'Shop' },
    'footer.about':    { pt: 'Sobre',         en: 'About' },
    'footer.lookbook': { pt: 'Lookbook',      en: 'Lookbook' },
    'footer.privacy':  { pt: 'Privacidade',   en: 'Privacy' },
    'footer.returns':  { pt: 'Trocas',        en: 'Returns' },
    'footer.terms':    { pt: 'Termos',        en: 'Terms' },
    'footer.rights':   { pt: 'Todos os direitos reservados.', en: 'All rights reserved.' },
    'footer.follow':   { pt: 'Nos siga',      en: 'Follow us' },
    'footer.newsletter_placeholder': { pt: 'Seu e-mail', en: 'Your email' },
    'footer.newsletter_btn': { pt: 'Entrar na Guerra', en: 'Join the War' },
    'footer.newsletter_label': { pt: 'Entre no exército. Sem spam.', en: 'Join the army. No spam.' },

    /* ── Página Woman ── */
    'woman.shop_training': { pt: 'Comprar Training →',   en: 'Shop Training →' },
    'woman.division':      { pt: 'DIVISÃO DE TREINO',     en: 'TRAINING DIVISION' },
    'woman.built':         { pt: 'FEITA PARA A GUERRA.',  en: 'BUILT FOR THE FIGHT.' },
    'woman.envio':         { pt: 'ENVIO PARA TODO BRASIL', en: 'SHIPPING ACROSS BRAZIL' },
    'woman.drop':          { pt: 'DROP LIMITADO',          en: 'LIMITED DROP' },
    'woman.perf':          { pt: 'PERFORMANCE + DESIGN',   en: 'PERFORMANCE + DESIGN' },
    'woman.training_title': { pt: 'THE TRAINING DIVISION', en: 'THE TRAINING DIVISION' },
    'woman.view_all':      { pt: 'VER TUDO →',             en: 'VIEW ALL →' },
    'woman.shop_cat':      { pt: 'SHOP BY CATEGORY',       en: 'SHOP BY CATEGORY' },
    'woman.shop_woman':    { pt: 'SHOP WOMAN →',           en: 'SHOP WOMAN →' },
    'woman.shop_look':     { pt: 'SHOP THE LOOK',          en: 'SHOP THE LOOK' },
    'woman.manifesto':     { pt: 'SHE WAS BUILT FOR THE FIGHT.', en: 'SHE WAS BUILT FOR THE FIGHT.' },
    'woman.war_over':      { pt: 'A GUERRA NÃO ACABOU.',    en: 'THE WAR IS NOT OVER.' },
    'woman.explore':       { pt: 'EXPLORE TRAINING →',      en: 'EXPLORE TRAINING →' },

    /* ── Preloader ── */
    'preloader.click': { pt: 'Clique para entrar', en: 'Click to enter' },

    /* ── Collection ── */
    'collection.eyebrow':  { pt: 'Coleção Completa', en: 'Full Collection' },
    'collection.products': { pt: 'Produtos',          en: 'Products' },
    'collection.filter':   { pt: 'Filtrar',           en: 'Filter' },
    'collection.sort':     { pt: 'Ordenar',           en: 'Sort' },
    'collection.load_more':{ pt: 'Ver mais',          en: 'Load more' },
    'collection.empty':    { pt: 'Nenhum produto encontrado.', en: 'No products found.' },

    /* ── Product page ── */
    'product.buy_now':     { pt: 'Comprar Agora',  en: 'Buy Now' },
    'product.description': { pt: 'Descrição',       en: 'Description' },
    'product.share':       { pt: 'Compartilhar',    en: 'Share' },
    'product.in_stock':    { pt: 'Em estoque',      en: 'In stock' },
    'product.out_stock':   { pt: 'Esgotado',        en: 'Out of stock' },

    /* ── Garage page ── */
    'garage.mission':   { pt: 'MISSÃO',          en: 'MISSION' },
    'garage.join':      { pt: 'Participar →',    en: 'Join →' },
    'garage.rules':     { pt: 'REGRAS',           en: 'RULES' },
    'garage.timeline':  { pt: 'HORÁRIOS',         en: 'SCHEDULE' },
  };

  /* ── Estado ── */
  function getLang() {
    return localStorage.getItem('dbc-lang') || 'pt';
  }

  /* ── Aplicar idioma ── */
  function applyLang(lang) {
    /* Atualiza todos os toggles (desktop + mobile) */
    document.querySelectorAll('#lang-toggle, #lang-toggle-mobile').forEach(function(toggle) {
      toggle.classList.toggle('lang-toggle--en', lang === 'en');
      toggle.classList.toggle('lang-toggle--pt', lang === 'pt');
      toggle.setAttribute('aria-checked', lang === 'en' ? 'true' : 'false');
    });

    // Aplica todas as strings [data-i18n]
    document.querySelectorAll('[data-i18n]').forEach(function(el) {
      var key = el.dataset.i18n;
      if (T[key] && T[key][lang] !== undefined) {
        if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
          el.placeholder = T[key][lang];
        } else {
          el.innerHTML = T[key][lang];
        }
      }
    });

    // html lang
    document.documentElement.lang = lang === 'pt' ? 'pt-BR' : 'en';
  }

  /* ── Toggle ── */
  window.toggleLang = function() {
    var cur = getLang();
    var next = cur === 'pt' ? 'en' : 'pt';
    localStorage.setItem('dbc-lang', next);
    applyLang(next);
  };

  /* ── Manter compatibilidade com setLang() ── */
  window.setLang = function(lang) {
    localStorage.setItem('dbc-lang', lang);
    applyLang(lang);
  };

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', function() {
    var lang = getLang();
    applyLang(lang);
    // Teclado: Enter/Space no toggle
    var toggle = document.getElementById('lang-toggle');
    if (toggle) {
      toggle.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleLang(); }
      });
    }
  });

})();
